export { default as AddPage } from './Add';
export { default as ViewPage } from './View';
